import React, { useEffect, useState, useRef } from 'react';
import Lottie from 'react-lottie';
import strings from '../../strings/strings.json'
import * as animationData from '../../assets/animation/wave.json'
import { initScan, scanResult, scanStop, startScan } from 'api/api_service';
import { IScanResult } from 'types';
import AvCard from './av_card';
import AvsResultStatus from './avs_result_status';
import { useHistory } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../state/actions";
import moment from 'moment-jalaali';
import { Popconfirm } from 'antd'
import Layout from 'components/layout';

const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    }
};
interface Props {
    location: any
}
let guid: string = ''

export default function ScanFile(props: Props) {

    const [avsResult, setAvsResult] = useState<IScanResult>(),
        [lastTime, setLastTime] = useState(moment(new Date())),
        dispatch = useDispatch(),
        avsData = props.location.state[0],
        paths = props.location.state[1],
        mountedRef = useRef(true),
        history = useHistory()
    let intervalId: any = null,
        timeIntervalId: any = null



    useEffect(() => {

        initScan({
            "paths": paths,
            "avs": avsData
        }).then(res => {
            if (res.status === 200 && res.data.success) {
                startScan({ "guid": res.data.guid })
                    .then(startRes => {
                        guid = res.data.guid
                        if (startRes.status === 200 && startRes.data.success) {
                            intervalId = setInterval(() => {
                                scanResult({ "guid": res.data.guid })
                                    .then(res => {
                                        setAvsResult(res.data.data)
                                        if (res.data.data.finished_at !== undefined || !mountedRef.current) {
                                            clearInterval(intervalId)
                                              history.push({
                                                  pathname: '/scanResult',
                                                  state: [guid, res.data.data]
                                              })
                                        }
                                    })
                            }, 5000)
                        }
                    })
            } else {
                dispatch(showSnackbar({ "open": true, severity: "error", msg: `${strings.scan_initError}` }));
                history.replace('/')
            }
        })
        return () => {
            mountedRef.current = false
            clearInterval(timeIntervalId)
        }

    }, [])

    const stopScanHandler = () => {

        function stopScanClicked() {
            scanStop({ "guid": guid })
                .then(res => {
                    if (res.status === 200 && res.data.success) {
                        dispatch(showSnackbar({ "open": true, severity: "success", msg: `${strings.scan_stop}` }));
                        mountedRef.current = false
                        clearInterval(timeIntervalId)
                    }
                })
        }
        return (
            <Popconfirm
                title={strings.public_stopScan}
                onConfirm={() => stopScanClicked()}
                okText={strings.public_yes}
                cancelText={strings.public_no}
                icon={''}
            >
                <button
                    className='rounded-full border border-black px-10 py-3'
                >
                    {strings.public_doStop}
                </button>
            </Popconfirm>
        )
    }

    const avCardDetailsHandler = (data: any, index: number) => {
        return (
            <div key={index} className={`${avsResult?.avs.length === 1 ? 'col-span-2' : 'col-span-1'} fade_in`}>
                <AvCard av_name={data} av_data={avsResult} />
            </div>
        )
    }

    const timeHandler = () => {

        let now = moment(new Date())
        var duration = moment.duration(now.diff(lastTime));
        let seconds = duration.asSeconds()
        var d = Math.floor(seconds / (3600 * 24));
        var h = Math.floor(seconds % (3600 * 24) / 3600);
        var m = Math.floor(seconds % 3600 / 60);
        var s = Math.floor(seconds % 60)
        return (
            <div className='text-xs secondry_text_color' dir='ltr'>{`${h < 10 ? `0${h}` : h} : ${m < 10 ? `0${m}` : m} : ${s < 10 ? `0${s}` : s}`}</div>
        )
    }

    return (
        <Layout>
            <div className='w-full h-full'>
                <div dir='rtl' className='grid grid-cols-6 h-full'>
                    {/* right side */}
                    <div className='col-span-5 flex flex-col justify-center items-center overflow-auto'>
                        <div className='flex justify-center items-center relative'>
                            <img src={require('../../assets/icons/mri.svg').default} alt="Icn" />
                            <div className='absolute'>
                                <Lottie options={defaultOptions}
                                    height={250}
                                    width={250}
                                />
                            </div>
                        </div>
                        <span className='primary_text_color font-bold text-lg mt-2'>{strings.public_scanning}...</span>
                        <div className='grid grid-cols-2 gap-2 mt-7'>
                            {
                                avsResult !== undefined &&
                                avsResult.avs.map(avCardDetailsHandler)
                            }
                        </div>
                        {
                            avsResult !== undefined &&
                            <div className='border border-gray-200 grid grid-cols-2 py-2 w-3/12 rounded-lg mt-10'>
                                <div className='flex flex-col items-center justify-center col-span-1'>
                                    <div className='text-sm primary_text_color font-bold'>{strings.public_spendtime}</div>
                                    {
                                        timeHandler()
                                    }

                                </div>
                                <div className='flex flex-col items-center border-r border-gray-200'>
                                    <span className='text-sm primary_text_color font-bold'>{strings.public_beginDate}</span>
                                    <span className='text-xs secondry_text_color mt-1 col-span-1'>{moment.unix(avsResult?.started_at).format("jYYYY/jM/jD")}</span>
                                </div>
                            </div>
                        }
                        {
                            avsResult !== undefined &&
                            <div className='mt-10'>
                                {stopScanHandler()}
                            </div>
                        }
                    </div>
                    {/* left side */}
                    <div className='col-span-1 border-r border-gray-200 h-full overflow-auto'>
                        <AvsResultStatus
                            data={avsResult?.malware.normal}
                            compressed={avsResult !== undefined && avsResult?.malware.compressed}
                        />
                    </div>
                </div>
            </div>
        </Layout>

    )
}
